<div class="video-container" [class.visible]="visible">
  <video
    #video
    class="video"
    muted
    playsinline
  ></video>
</div>
